module.exports = __webpack_public_path__ + "static/media/WeatherStation.52592f7e.jpg";